import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import helpCenterData from '../../data/helpCenter';
import withComponentName from '../../decorators/withComponentName';
import withMetatag from '../../decorators/metadataDecorators/metatagsTitleDecorator';

import HelpCenterTabs from './HelpCenterTabs';
import HelpCenterSlider from './HelpCenterSlider';
import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const HelpCenterComponent = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [subCategories, setSubCategories] = useState();
  const { tab, video, device } = useParams();

  const { searchBarActive } = useSelector((state) => state.searchReducers);

  const handleTabClick = (id) => {
    setActiveTab(id);
    const subCat = helpCenterData.filter((helpObj) => helpObj.id === id);
    setSubCategories(subCat[0].subTabs);
  };

  useEffect(() => {
    if (!tab) return;
    const activeTab = helpCenterData.find((activeTab) => activeTab.tabPath === tab);
    handleTabClick(activeTab.id);
  }, [tab]);

  return (
    <div className={cx('help_center_page', searchBarActive && Styles.blurred)}>
      <div className={cx('help_center')}>
        <h3>Video Tutorials</h3>
        <div className={cx('help_center_description')}>
          Explore dozens of videos to learn more about our product.
        </div>
        <div className={cx('help_center_tabs')}>
          <HelpCenterTabs
            tabs={helpCenterData}
            activeTab={activeTab}
            onTabClick={handleTabClick}
          />
        </div>
        <HelpCenterSlider
          key={activeTab}
          tab={tab}
          video={video}
          device={device}
          subCategories={subCategories}
        />
        <div className={Styles['help_center-footer']}>
          <p>
            Visit our &nbsp;
            <a
              href="https://help.cityfalcon.com/hc/en-us"
              target="_blank"
              rel="noopener noreferrer"
            >
              knowledge base
            </a>
            &nbsp;to learn more.
          </p>
        </div>
      </div>
    </div>
  );
};

export default withMetatag(
  withComponentName(HelpCenterComponent),
  'help-videos',
);
